// Temporary styles - will be removed once we can access them through styleguide.
export enum Gray {
  x100 = '#000000',
  x200 = '#D2D2D2',
  x300 = '#F5F5F5',
  x400 = '#EEEEEE',
}

export enum Shade {
  x400 = '4px 4px 12px rgb(0, 0, 0, 0.2)',
  x500 = '0 0 35px rgba(0, 0, 0, 0.2)',
}
